import React, { useState, useEffect } from 'react'
import './LegacyCredits.css'
import PageTitle from '../../components/UI/PageTitle'
import LegacyCreditUserCard from '../../components/admin/LegacyCreditUserCard'
import Separator from '../../components/UI/Separator'
import { getMonthlyLegacyCredits } from '../../api/Index';

const LegacyCredits = () => {
    const [legacyCredits, setLegacyCredits] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

    const fetchLegacyCredits = async () => {
        setLoading(true);
        setError(null);
        
        try {
            // Backend expects month (1-12) and year as separate query parameters
            const month = selectedMonth + 1; // Convert from 0-based to 1-based month
            const year = selectedYear;
            
            const response = await getMonthlyLegacyCredits(month, year);
            setLegacyCredits(Array.isArray(response.data) ? response.data : []);
        } catch (err) {
            console.error('Error fetching legacy credits:', err);
            setError(err.message || 'Failed to load legacy credits');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLegacyCredits();
    }, [selectedMonth, selectedYear]);


  if (loading) {
        return (
            <div>
                <PageTitle title='Legacy Credits' />
                <div>Loading legacy credits...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <PageTitle title='Legacy Credits' />
                <div style={{color: 'red'}}>Error: {error}</div>
            </div>
        );
    }

  return (
    <div>
        <PageTitle title='Legacy Credits' />
        
        <div className='select-group'>
            <div className='select'>
                <label>Month:</label>
                <select 
                    value={selectedMonth} 
                    onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                >
                    {months.map((month, index) => (
                        <option key={index} value={index}>
                            {month}
                        </option>
                    ))}
                </select>
            </div>
            
            <div className='select'>
                <label>Year:</label>
                <select 
                    value={selectedYear} 
                    onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                >
                    {years.map(year => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
            </div>
        </div>

        <div>
            {legacyCredits.length === 0 ? (
                <div>No legacy credits found for {months[selectedMonth]} {selectedYear}</div>
            ) : (
                legacyCredits.map((report, index) => (
                    <React.Fragment key={report.user?.id || index}>
                        <Separator />
                        <LegacyCreditUserCard
                            name={report.user?.name}
                            email={report.user?.email}      
                            legacyCreditsAmount={report.legacyCredit?.amount || 0}
                            paidAmount={report.legacyCredit?.price || 1000}
                            status={report.legacyCredit?.status || 'pending'}
                        />
                    </React.Fragment>
                ))
            )}
        </div>
    </div>
  )
}

export default LegacyCredits